import { Components, Theme } from '@mui/material';
import { common } from '@mui/material/colors';
import { wbTheme, wbColors as colors } from '@workbuzz/shared-ui';

export const MuiOutlinedInputStyles: Components<Omit<Theme, 'components'>> = {
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        width: '100%',
        borderRadius: '6px',
        backgroundColor: common.white,
        color: colors.doveGray,
        '&:hover': {
          backgroundColor: colors.mineShaft1,
          color: colors.doveGray,
          '& .MuiOutlinedInput-notchedOutline': {
            backgroundColor: colors.mineShaft1,
          },
        },

        '&:focus-within': {
          outline: `${colors.cornflowerBlue} solid 3px`,
          borderRadius: '6px',
          '& > .MuiOutlinedInput-notchedOutline': {
            border: `2px solid ${colors.mineShaft}`,
          },
        },

        '&.Mui-error': {
          '&:focus-within': {
            '& > .MuiOutlinedInput-notchedOutline': {
              border: `2px solid ${colors.cardinal}`,
            },
          },
          '&.Mui-disabled': {
            '& > .MuiOutlinedInput-notchedOutline': {
              border: `2px solid ${colors.cardinal}`,
              opacity: 0.3,
            },
            '& > .MuiBox-root': {
              '& > .MuiIcon-root.MuiIcon-colorError': {
                opacity: 0.3,
              },
            },
          },
        },
        // Select specific
        '&.Mui-placeholder .MuiSelect-select': {
          color: colors.doveGray,
        },
        '&.Mui-focused': {
          outline: `${colors.cornflowerBlue} solid 3px`,
          '& > .MuiOutlinedInput-notchedOutline': {
            border: `2px solid ${colors.mineShaft}`,
          },
        },
        '&.MuiSelect.Mui-disabled': {
          '&.Mui-error': {
            '& > .MuiOutlinedInput-notchedOutline': {
              border: `2px solid ${colors.cinderella}`,
              opacity: 0.3,
            },
          },
          '& > .MuiOutlinedInput-notchedOutline': {
            border: `2px solid ${colors.iron}`,
            opacity: 0.3,
          },
          '& > .MuiBox-root': {
            '& > .MuiIcon-root.MuiIcon-colorSuccess': {
              opacity: 0.3,
            },
          },
          '&:hover': {
            '.MuiOutlinedInput-notchedOutline': {
              background: `${colors.mineShaft}0C`,
              color: colors.mineShaft,
            },
          },
          '&:focus-within': {
            '.MuiOutlinedInput-notchedOutline': {
              background: `${colors.mineShaft}0C`,
              color: colors.mineShaft,
            },
          },
        },
      },
      notchedOutline: {
        border: `2px solid ${colors.iron}`,
      },
      input: {
        padding: wbTheme.spacing(1.25, 2),
        zIndex: 1,
      },
    },
  },
};
